import { render, staticRenderFns } from "./QuotationForm.vue?vue&type=template&id=a06b7084&scoped=true"
import script from "./QuotationForm.vue?vue&type=script&lang=js"
export * from "./QuotationForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationForm.vue?vue&type=style&index=0&id=a06b7084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b7084",
  null
  
)

export default component.exports